"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Tests whether an element is a tag or not.
 *
 * @param elem Element to test
 */

function isTag(elem) {
  return elem.type === "tag"
  /* Tag */
  || elem.type === "script"
  /* Script */
  || elem.type === "style"
  /* Style */
  ;
}

exports.isTag = isTag; // Exports for backwards compatibility

exports.Text = "text"
/* Text */
; //Text

exports.Directive = "directive"
/* Directive */
; //<? ... ?>

exports.Comment = "comment"
/* Comment */
; //<!-- ... -->

exports.Script = "script"
/* Script */
; //<script> tags

exports.Style = "style"
/* Style */
; //<style> tags

exports.Tag = "tag"
/* Tag */
; //Any tag

exports.CDATA = "cdata"
/* CDATA */
; //<![CDATA[ ... ]]>

exports.Doctype = "doctype"
/* Doctype */
;